@use '@/styles/tokens' as *;

.grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: var(--space-5);

  @include up('sm') {
    grid-template-columns: repeat(2, 1fr);
  }

  @include up('lg') {
    grid-template-columns: repeat(3, 1fr);
  }
}
